import * as React from "react";
import { Box } from "@twilio-paste/box";
import { styled } from "@twilio-paste/styling-library";
var RATIO_REGEX = /^(\d+:\d*)$/,
  isCorrectPattern = ratio => RATIO_REGEX.test(ratio),
  handlePropValidation = _ref => {
    let {
      ratio
    } = _ref;
    if (!(ratio != null && ratio !== "")) throw new Error("[Paste: AspectRatio] Missing 'ratio' prop.");
    if (!isCorrectPattern(ratio)) throw new Error("[Paste: AspectRatio] 'ratio' is invalid. Use a colon separated number pattern (4:3).");
  },
  AspectRatioContainer = styled.div`
  position: relative;

  embed,
  iframe,
  object,
  video {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
`,
  AspectRatio = React.forwardRef((props, ref) => {
    handlePropValidation(props);
    let aspectArray = props.ratio.split(":").map(Number),
      aspectPercent = aspectArray[1] / aspectArray[0] * 100;
    return React.createElement(AspectRatioContainer, {
      ref,
      style: {
        paddingBottom: `${aspectPercent}%`
      }
    }, React.createElement(Box, {
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }, props.children));
  });
AspectRatio.displayName = "AspectRatio";
export { AspectRatio };